module.exports = __webpack_public_path__ + "static/media/search-dollar.a5bb6d3e.svg";